import { CardData, CheckData } from '../billing-info/billing-info.model';
import { Organization } from '../organization/organization.model';

export enum InvoiceStatus {
    OPEN = 'open',
        PAID = 'paid',
        OUTSTANDING = 'outstanding',
        DELINQUENT = 'delinquent',
        UNCOLLECTIBLE = 'uncollectible'
}

export interface PaymentInfoModel {
    type: string;
    firstName: string;
    lastName: string;
    compDate: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    phone: string;
    email: string;

    card: CardData;
    check: CheckData;
}

const invoiceFields = {
    id: { required: true },
    createdAt: { required: true },
    updatedAt: { required: true },
    status: { required: true },
    periodStart: { required: true },
    periodEnd: { required: true },
    outstandingDeadline: { required: true },
    delinquentDeadline: { required: true },
    nextReminderDate: { required: true },
    subtotalAmount: { required: true },
    discountAmount: { required: true },
    totalAmount: { required: true },
    amountRemaining: { required: true },
    amountPaid: { required: true },
    creditsUsed: { required: true },
    complementaryCredits: { required: true },
    organizationId: { required: true },
    organization: { required: true },
    subscriptionId: { required: true },
    transactionId: { required: true }
};

export class Invoice {

    constructor(inv: Partial<Invoice>) {
        Object.assign(this, inv);
        for(const key in invoiceFields)
            if (this[key] == null && invoiceFields[key].required)
                throw Error(`${key} cannot be null`);
    }

    id: string;
    createdAt: Date;
    updatedAt: Date;

    status: InvoiceStatus;

    periodStart: Date;
    periodEnd: Date;

    outstandingDeadline: Date;
    delinquentDeadline: Date;
    nextReminderDate: Date;

    subtotalAmount: number;
    discountAmount: number;
    totalAmount: number;
    amountRemaining: number;
    amountPaid: number;

    creditsUsed: number;
    complementaryCredits: number;

    organizationId: string;
    organization: Organization;

    subscriptionId: string;

    transactionId: string;
}
